import { useMemo } from "react";

import { IHandBookTemplateExpenditure, IMaterialInHandbookExpenditure } from "pages/HandBook/model/types";
import { filterExpenditureMaterials } from "pages/HandBook/utils/handbooksModifyWithEditings";

import TemplateAddExpenditure from "../../../../ui/TemplateAddExpenditure/TemplateAddExpenditure";
import useHandBooksTemplatesRow from "../../useHandBooksTemplatesRow";
import { ICommonColumn } from "../templates/HandBooksTemplates";
import { useTypedSelector } from "app/store/typedUseSelector";
import Actions from "shared/ui/controls/Actions/Actions";
import TableReusableRow, { TableReusableCell } from "shared/ui/dataDisplay/TableReusable/TableReusableRow";
import RowGrid from "shared/ui/layout/RowGrid/RowGrid";

import styles from "./HandBooksTemplateExpenditureRow.module.scss";

interface HandBooksTemplateExpenditureRowProps<TItem extends Record<string, any>> {
  item: TItem;
  sectionId: number;
  colPercents: number[];
  formColPercents: number[];
  columns: ICommonColumn<TItem>[];
  hiddenCols: Record<string, boolean>;
}

const HandBooksTemplateExpenditureRow = ({
  item,
  sectionId,
  colPercents,
  formColPercents,
  columns,
  hiddenCols,
}: HandBooksTemplateExpenditureRowProps<IHandBookTemplateExpenditure>) => {
  const { isEditing } = useHandBooksTemplatesRow(item.id);
  const templateViewFilters = useTypedSelector((state) => state.handBookReducer.templateViewFilters);
  const materials = useMemo(
    () => filterExpenditureMaterials(item.materials, templateViewFilters),
    [item.materials, templateViewFilters]
  );

  const displayEl = (x: IHandBookTemplateExpenditure | IMaterialInHandbookExpenditure, onDelete?: () => void) => {
    const cols = onDelete ? formColPercents : colPercents;
    return (
      <TableReusableRow
        key={x.id}
        isHoverable={false}
        containerClassName={onDelete ? styles.existingMaterialRow : styles.workRow}
      >
        <RowGrid percents={cols}>
          {onDelete ? <div /> : null}
          {/* @ts-ignore */}
          {columns.map((el, index) => (
            <TableReusableCell isCentered={el.isCentered} isNoBreak={el.isNoBreak} isRighted={el.isRighted} key={index}>
              {/* @ts-ignore */}
              {el.render({ ...x, segment: item.segment })}
            </TableReusableCell>
          ))}
          {onDelete ? (
            <Actions canRemove className={styles.deleteAction} onRemoveDirectly={onDelete} deleteLabel="Удалить" />
          ) : null}
        </RowGrid>
      </TableReusableRow>
    );
  };

  if (isEditing) {
    // Не рендерим редактирование для ресурсов, не привязанных к работам
    if (item.manual_expenditure?.type && item.manual_expenditure.type !== "work") {
      return null;
    }
    return <TemplateAddExpenditure item={item} sectionId={sectionId} hiddenCols={hiddenCols} />;
  }

  return (
    <>
      {displayEl(item)}
      {materials?.map((m) => displayEl(m))}
    </>
  );
};
export default HandBooksTemplateExpenditureRow;
